/* Picura Pakete – Branchen-Funnel auf der Branchenseite.
   Drei Schritte auf der Branchenseite: Paket waehlen, Paket anpassen, Kontakt.
   Die Produkte kommen als Bloecke aus dem Theme-Editor und stehen als JSON in der Seite.
   Versand wie bei den uebrigen Picura-Formularen: POST in ein verstecktes iframe,
   Antwort per postMessage {type:'picuraFormResult'}. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.pkReady) return;
    root.dataset.pkReady = '1';

    var cfg = {};
    var liste = [];
    try { cfg = JSON.parse(root.querySelector('[data-pk-config]').textContent); } catch (e) { cfg = {}; }
    try { liste = (JSON.parse(root.querySelector('[data-pk-katalog]').textContent) || {}).leistungen || []; } catch (e) { liste = []; }

    var katalog = {};
    liste.forEach(function (l) { katalog[l.id] = l; });

    var form = root.querySelector('.pk-form');
    var steps = Array.prototype.slice.call(root.querySelectorAll('.pk-step'));
    var stepItems = Array.prototype.slice.call(root.querySelectorAll('[data-pk-stepitem]'));
    var done = root.querySelector('[data-pk-done]');
    var msg = root.querySelector('[data-pk-msg]');
    var submit = root.querySelector('[data-pk-submit]');
    var kicker = root.querySelector('[data-pk-kicker]');
    var current = root.querySelector('[data-pk-current]');
    var storeKey = 'picura-pakete2:' + (cfg.storageKey || 'default');
    /* Zeitprüfung ab der ersten Eingabe, nicht ab dem Seitenaufruf — wer einen
       gespeicherten Stand fortsetzte, bekam sonst „zu schnell“. */
    var started = 0;
    var sendTimer = null;
    var core = window.PicuraForm || null;
    var leadId = '';
    var iframe = form ? document.querySelector('iframe[name="' + form.getAttribute('target') + '"]') : null;

    if (!form || !steps.length) return;
    root.classList.add('is-js');

    var auswahl = { paket: '', paketName: '', ids: [] };
    var index = 1;

    /* ---------- Hilfsfunktionen ---------- */
    function preisText(zahl) {
      return String(Math.round(zahl)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function summe(ids) {
      var s = 0;
      ids.forEach(function (id) { if (katalog[id]) s += katalog[id].preis; });
      return s;
    }

    function idsFuer(key) {
      return liste.filter(function (l) { return l[key]; }).map(function (l) { return l.id; });
    }

    function setError(el, text) {
      var box = el.closest('.pk-feld') || el.closest('.pk-consent');
      var out = box ? box.querySelector('.pk-feld-fehler') : null;
      el.setAttribute('aria-invalid', text ? 'true' : 'false');
      if (out) out.textContent = text || '';
    }

    /* ---------- Anzeige ---------- */
    function headerOffset() {
      var found = 0;
      var cands = document.querySelectorAll('.shopify-section-group-header-group, .pch, header, .header, .announcement-bar');
      Array.prototype.forEach.call(cands, function (el) {
        var pos = getComputedStyle(el).position;
        if (pos !== 'sticky' && pos !== 'fixed') return;
        var box = el.getBoundingClientRect();
        if (box.bottom <= 0 || box.top > 160 || box.height < 20) return;
        if (box.bottom > found) found = box.bottom;
      });
      return Math.min(found, 200);
    }

    function scrollHierher() {
      var off = headerOffset() + 12;
      var top = window.pageYOffset + root.getBoundingClientRect().top - off;
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: smooth ? 'smooth' : 'auto' });
    }

    function show(nr, focus) {
      index = nr;
      steps.forEach(function (s) {
        var an = parseInt(s.dataset.pkStep, 10) === nr;
        s.hidden = !an;
        s.classList.toggle('is-active', an);
      });
      stepItems.forEach(function (item) {
        var n = parseInt(item.dataset.pkStepitem, 10);
        item.classList.toggle('is-done', n < nr);
        item.classList.toggle('is-active', n === nr);
        var btn = item.querySelector('[data-pk-goto]');
        if (btn) {
          /* Zurueck darf man immer, vorwaerts erst wenn ein Paket gewaehlt ist */
          btn.disabled = !(n <= nr || auswahl.ids.length);
        }
      });
      if (current) current.textContent = String(nr);
      if (nr === 3 && core) {
        /* Kontaktdaten aus dem Branchen-Check derselben Sitzung übernehmen */
        var k = core.kontakt(), teile = core.nameTeilen(k.name || '');
        [['vorname', teile.vorname], ['nachname', teile.nachname !== '–' ? teile.nachname : ''], ['email', k.email], ['telefon', k.telefon], ['unternehmen', k.firma]].forEach(function (x) {
          var f = form.querySelector('[name="' + x[0] + '"]');
          if (f && !f.value && x[1]) f.value = x[1];
        });
      }
      if (core && nr > 1) core.track('picura_form_step', { form_id: 'pakete', step_name: nr === 2 ? 'anpassen' : 'kontakt', step_number: nr, step_count: 3, paket: auswahl.paket || '', branche: cfg.branche || '' });
      if (kicker) kicker.hidden = false;
      if (msg) { msg.textContent = ''; msg.classList.remove('is-info'); }
      if (focus !== false) {
        var head = steps.filter(function (s) { return parseInt(s.dataset.pkStep, 10) === nr; })[0];
        var h = head && head.querySelector('.pk-h');
        if (h) h.focus({ preventScroll: true });
        scrollHierher();
      }
      save();
    }

    /* ---------- Schritt 2 aufbauen ---------- */
    function zeile(id, imPaket) {
      var l = katalog[id];
      if (!l) return null;
      var li = document.createElement('li');
      li.className = 'pk-zeile';
      li.dataset.pkZeile = id;

      var bild = document.createElement('span');
      bild.className = 'pk-zeile__bild';
      if (l.bild) {
        var img = document.createElement('img');
        img.src = l.bild;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 64;
        img.height = 64;
        bild.appendChild(img);
      } else {
        bild.classList.add('is-leer');
      }
      li.appendChild(bild);

      var body = document.createElement('div');
      body.className = 'pk-zeile__body';
      if (l.kategorie) {
        var kat = document.createElement('span');
        kat.className = 'pk-zeile__kat';
        kat.textContent = l.kategorie;
        body.appendChild(kat);
      }
      var name = document.createElement('span');
      name.className = 'pk-zeile__name';
      name.textContent = l.name;
      body.appendChild(name);
      if (l.text) {
        var t = document.createElement('span');
        t.className = 'pk-zeile__text';
        t.textContent = l.text;
        body.appendChild(t);
      }
      li.appendChild(body);

      var rechts = document.createElement('div');
      rechts.className = 'pk-zeile__rechts';
      var preis = document.createElement('span');
      preis.className = 'pk-zeile__preis';
      preis.textContent = 'ab ' + preisText(l.preis) + ' €';
      rechts.appendChild(preis);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pk-zeile__btn';
      btn.textContent = imPaket ? 'Entfernen' : 'Hinzufügen';
      btn.dataset.pkToggle = id;
      rechts.appendChild(btn);
      li.appendChild(rechts);
      return li;
    }

    function renderAnpassen() {
      var posten = root.querySelector('[data-pk-posten]');
      var addons = root.querySelector('[data-pk-addons]');
      var addonsTitel = root.querySelector('[data-pk-addons-titel]');
      if (!posten || !addons) return;

      posten.innerHTML = '';
      auswahl.ids.forEach(function (id) {
        var li = zeile(id, true);
        if (li) posten.appendChild(li);
      });

      addons.innerHTML = '';
      var feld = 'zusatz_' + (auswahl.paket || 'starter');
      var offen = liste.filter(function (l) {
        return l[feld] && auswahl.ids.indexOf(l.id) === -1;
      });
      offen.forEach(function (l) {
        var li = zeile(l.id, false);
        if (li) addons.appendChild(li);
      });
      if (addonsTitel) addonsTitel.hidden = offen.length === 0;
      addons.hidden = offen.length === 0;

      updateSumme();
    }

    function updateSumme() {
      var s = summe(auswahl.ids);
      var setze = function (sel, wert) {
        var el = root.querySelector(sel);
        if (el) el.textContent = wert;
      };
      setze('[data-pk-summe-name]', auswahl.paketName);
      setze('[data-pk-summe-anzahl]', String(auswahl.ids.length));
      setze('[data-pk-summe-preis]', preisText(s));
      setze('[data-pk-ueb-paket]', auswahl.paketName || '–');
      setze('[data-pk-ueb-anzahl]', String(auswahl.ids.length));
      setze('[data-pk-ueb-preis]', preisText(s));
      var weiter = root.querySelector('[data-pk-weiter]');
      if (weiter) weiter.disabled = auswahl.ids.length === 0;
    }

    /* ---------- Paket waehlen ---------- */
    function waehle(karte, sofort) {
      var key = karte.dataset.pkKey;
      auswahl.paket = key;
      var titel = karte.querySelector('.pk-karte__titel');
      auswahl.paketName = titel ? titel.textContent.trim() : key;
      auswahl.ids = idsFuer(key);
      renderAnpassen();
      if (sofort) { show(2); return; }
      wartenDann(function () { show(2); });
    }

    /* Kurze Rueckmeldung, damit der Wechsel nicht abrupt wirkt */
    function wartenDann(fn) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { fn(); return; }
      var host = steps.filter(function (s) { return parseInt(s.dataset.pkStep, 10) === 1; })[0];
      if (!host) { fn(); return; }
      var box = document.createElement('div');
      box.className = 'pk-wait';
      box.innerHTML = '<p></p><div class="pk-wait__bar"><span></span></div><small>Einen Moment bitte</small>';
      box.querySelector('p').textContent = (cfg.waitText || 'Wir stellen Ihr Paket zusammen') + ' – ' + auswahl.paketName;
      var vorher = Array.prototype.slice.call(host.children);
      vorher.forEach(function (el) { el.style.display = 'none'; });
      host.appendChild(box);
      scrollHierher();
      requestAnimationFrame(function () { box.querySelector('.pk-wait__bar span').style.width = '100%'; });
      setTimeout(function () {
        box.remove();
        vorher.forEach(function (el) { el.style.display = ''; });
        fn();
      }, 700);
    }

    /* ---------- Zwischenstand ---------- */
    function save() {
      try {
        sessionStorage.setItem(storeKey, JSON.stringify({ step: index, auswahl: auswahl }));
      } catch (e) { /* privater Modus */ }
    }

    function restore() {
      var data = null;
      try { data = JSON.parse(sessionStorage.getItem(storeKey) || 'null'); } catch (e) { data = null; }
      if (!data || !data.auswahl || !data.auswahl.ids || !data.auswahl.ids.length) return false;
      /* Nur Leistungen uebernehmen, die es noch gibt */
      data.auswahl.ids = data.auswahl.ids.filter(function (id) { return katalog[id]; });
      if (!data.auswahl.ids.length) return false;
      auswahl = data.auswahl;
      renderAnpassen();
      return data.step >= 2 ? data.step : 2;
    }

    /* ---------- Pruefung ---------- */
    function validate() {
      var ok = true, erstes = null;
      var felder = Array.prototype.slice.call(form.querySelectorAll('input, textarea'));
      felder.forEach(function (el) {
        if (el.type === 'hidden' || !el.required) return;
        var bad = '';
        if (el.type === 'checkbox') { if (!el.checked) bad = 'Bitte bestätigen.'; }
        else if (!el.value.trim()) bad = 'Bitte ausfüllen.';
        else if (!el.checkValidity()) bad = 'Bitte prüfen.';
        setError(el, bad);
        if (bad) { ok = false; if (!erstes) erstes = el; }
      });
      /* E-Mail ODER Telefon (Oktober 2026). Die Form-API verlangt beide
         Felder — das fehlende wird beim Absenden mit „nicht angegeben“ gefüllt. */
      var mail = form.email ? form.email.value.trim() : '';
      var tel = form.telefon ? form.telefon.value.trim() : '';
      var kf = root.querySelector('[data-pk-kontakt-fehler]');
      if (kf) kf.textContent = '';
      if (!mail && !tel) {
        ok = false;
        if (kf) kf.textContent = 'Bitte geben Sie eine E-Mail-Adresse oder eine Telefonnummer an.';
        if (!erstes) erstes = form.email || form.telefon;
      }
      if (mail && form.email && (core ? !core.emailOk(mail) : !form.email.checkValidity())) {
        ok = false; setError(form.email, 'Bitte prüfen Sie die E-Mail-Adresse.');
        if (!erstes) erstes = form.email;
      }
      if (tel && core && !core.telefonOk(tel)) {
        ok = false; setError(form.telefon, 'Bitte prüfen Sie die Telefonnummer.');
        if (!erstes) erstes = form.telefon;
      }
      if (!ok && erstes) erstes.focus();
      if (!ok && core) core.track('picura_form_error', { form_id: 'pakete', step_name: 'kontakt' });
      return ok;
    }

    /* ---------- Tracking ---------- */
    function track() {
      if (core) {
        core.lead({ lead_id: leadId, form_type: cfg.formType || 'Paket-Anfrage', form_id: 'pakete', branche: cfg.branche || '', paket: auswahl.paketName, seite: location.pathname, value: summe(auswahl.ids) });
        return;
      }
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'generate_lead',
          form_type: cfg.formType || 'Paket-Anfrage',
          form_context: cfg.branche || '',
          paket: auswahl.paketName,
          value: summe(auswahl.ids),
          currency: 'EUR'
        });
      } catch (e) { /* Tracking ist nie kritisch */ }
      try {
        var p = window.Shopify && window.Shopify.customerPrivacy;
        if (typeof window.fbq === 'function' && p && p.marketingAllowed && p.marketingAllowed()) {
          window.fbq('track', 'Lead', { content_name: cfg.formType || 'Paket-Anfrage', value: summe(auswahl.ids), currency: 'EUR' });
        }
      } catch (e) { /* Tracking ist nie kritisch */ }
    }

    /* ---------- Ereignisse ---------- */
    root.addEventListener('click', function (e) {
      var target = e.target;
      if (!target.closest) return;

      var mehr = target.closest('[data-pk-mehr]');
      if (mehr) {
        var karte = mehr.closest('.pk-karte');
        var offen = karte.classList.toggle('is-offen');
        mehr.setAttribute('aria-expanded', offen ? 'true' : 'false');
        var anzahl = karte.querySelectorAll('.pk-pos').length;
        var label = mehr.querySelector('[data-pk-mehr-text]');
        if (label) label.textContent = offen ? 'Weniger anzeigen' : 'Alle ' + anzahl + ' Leistungen anzeigen';
        return;
      }

      var direkt = target.closest('[data-pk-direkt]');
      if (direkt) {
        e.preventDefault();
        waehle(direkt.closest('.pk-karte'), true);
        show(3);
        return;
      }

      var waehlen = target.closest('[data-pk-waehlen]');
      if (waehlen) {
        e.preventDefault();
        waehle(waehlen.closest('.pk-karte'));
        return;
      }

      var toggle = target.closest('[data-pk-toggle]');
      if (toggle) {
        var id = toggle.dataset.pkToggle;
        var pos = auswahl.ids.indexOf(id);
        if (pos > -1) auswahl.ids.splice(pos, 1);
        else auswahl.ids.push(id);
        renderAnpassen();
        save();
        return;
      }

      var goto = target.closest('[data-pk-goto]');
      if (goto && !goto.disabled) {
        show(parseInt(goto.dataset.pkGoto, 10) || 1);
        return;
      }

      var weiter = target.closest('[data-pk-weiter]');
      if (weiter) { show(3); return; }

      var zurueck = target.closest('[data-pk-zurueck]');
      if (zurueck) { show(parseInt(zurueck.dataset.pkZurueck, 10) || 1); return; }

      var restart = target.closest('[data-pk-restart]');
      if (restart) {
        try { sessionStorage.removeItem(storeKey); } catch (err) { /* egal */ }
        form.reset();
        auswahl = { paket: '', paketName: '', ids: [] };
        renderAnpassen();
        if (done) done.hidden = true;
        started = 0;
        show(1);
      }
    });

    /* ---------- Versand ---------- */
    function hidden(name, wert) {
      var el = form.querySelector('input[type="hidden"][name="' + name + '"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        form.appendChild(el);
      }
      el.value = wert;
    }

    function zusammenfassung() {
      var zeilen = [];
      zeilen.push('Branche: ' + (cfg.branche || ''));
      zeilen.push('Paket: ' + auswahl.paketName);
      zeilen.push('Richtpreis (ab): ' + preisText(summe(auswahl.ids)) + ' EUR netto');
      zeilen.push('');
      zeilen.push('Leistungen (' + auswahl.ids.length + '):');
      auswahl.ids.forEach(function (id) {
        var l = katalog[id];
        if (l) zeilen.push('- ' + l.name + ' (ab ' + preisText(l.preis) + ' EUR)');
      });
      var design = form.querySelector('input[name="design"]:checked');
      if (design) { zeilen.push(''); zeilen.push('Design: ' + design.value); }
      var text = form.querySelector('textarea[name="anmerkungen"]');
      if (text && text.value.trim()) { zeilen.push(''); zeilen.push('Anmerkungen: ' + text.value.trim()); }
      var mail = form.email ? form.email.value.trim() : '', tel = form.telefon ? form.telefon.value.trim() : '';
      var kontakt = ['', 'KONTAKT', '  Name: ' + (form.vorname.value + ' ' + form.nachname.value).trim()];
      if (form.unternehmen && form.unternehmen.value.trim()) kontakt.push('  Firma: ' + form.unternehmen.value.trim());
      kontakt.push('  E-Mail: ' + (mail || 'nicht angegeben – bitte telefonisch melden'));
      kontakt.push('  Telefon: ' + (tel || 'nicht angegeben'));
      zeilen = ['PAKET-ANFRAGE · ' + leadId + ' · ' + (cfg.branche || '') + ' (' + location.pathname + ')', ''].concat(zeilen, kontakt);
      if (core) { zeilen.push(''); zeilen.push('HERKUNFT'); core.herkunftZeilen().forEach(function (z) { zeilen.push('  ' + z); }); }
      return zeilen.join('\n');
    }

    form.addEventListener('submit', function (e) {
      if (!validate()) { e.preventDefault(); return; }
      var hp = form.querySelector('input[name="website"]');
      if (hp && hp.value) { e.preventDefault(); return; }
      if (started && Date.now() - started < 3000) {
        /* Zu schnell: still warten und dann selbst absenden, statt zu schimpfen */
        e.preventDefault();
        setTimeout(function () { if (form.requestSubmit) form.requestSubmit(submit); else form.submit(); }, 3100 - (Date.now() - started));
        return;
      }
      Array.prototype.forEach.call(form.querySelectorAll('[data-pk-platzhalter]'), function (x) { x.parentNode.removeChild(x); });
      leadId = core ? core.leadId() : '';
      function platz(name, wert) { hidden(name, wert); var x = form.querySelector('input[type="hidden"][name="' + name + '"]'); x.setAttribute('data-pk-platzhalter', ''); }
      if (form.email && !form.email.value.trim()) { form.email.disabled = true; platz('email', 'nicht angegeben'); }
      if (form.telefon && !form.telefon.value.trim()) { form.telefon.disabled = true; platz('telefon', 'nicht angegeben'); }
      if (leadId) platz('lead_id', leadId);
      if (core) core.herkunftFelder(form);
      setTimeout(function () { if (form.email) form.email.disabled = false; if (form.telefon) form.telefon.disabled = false; }, 0);

      var namen = auswahl.ids.map(function (id) {
        return katalog[id] ? katalog[id].name : id;
      });
      var text = zusammenfassung();

      hidden('paket', auswahl.paketName);
      hidden('leistungen', namen.join(', '));
      hidden('richtpreis', preisText(summe(auswahl.ids)) + ' EUR netto');
      hidden('seite', location.pathname);
      hidden('name', (form.vorname.value + ' ' + form.nachname.value).trim());
      hidden('phone', (form.telefon && form.telefon.value.trim()) || 'nicht angegeben');
      hidden('message', text);
      /* Die Picura-Form-API druckt in der E-Mail nur das Feld nachricht */
      hidden('nachricht', text);

      if (msg) { msg.classList.add('is-info'); msg.textContent = cfg.sending || 'Wird gesendet …'; }
      if (submit) submit.disabled = true;

      clearTimeout(sendTimer);
      sendTimer = setTimeout(function () {
        if (done && !done.hidden) return;
        if (submit) submit.disabled = false;
        if (msg) {
          msg.classList.remove('is-info');
          msg.textContent = cfg.errorSend || 'Beim Versenden ist etwas schiefgelaufen. Bitte rufen Sie uns kurz an.';
        }
        if (core) core.track('picura_form_fail', { form_id: 'pakete', reason: 'timeout' });
      }, 20000);
    });

    var zielOrigin = '';
    try { zielOrigin = new URL(form.getAttribute('action'), location.href).origin; } catch (e) { zielOrigin = ''; }
    window.addEventListener('message', function (event) {
      if (!event.data || event.data.type !== 'picuraFormResult') return;
      /* Nur die Antwort aus dem eigenen iframe — sonst zeigte ein Erfolg eines
         anderen Formulars auf derselben Seite auch hier „Danke“. */
      if (iframe && event.source !== iframe.contentWindow) return;
      if (zielOrigin && event.origin && event.origin !== zielOrigin) return;
      clearTimeout(sendTimer);
      if (submit) submit.disabled = false;
      if (msg) msg.classList.remove('is-info');
      if (event.data.success) {
        if (msg) msg.textContent = '';
        try { sessionStorage.removeItem(storeKey); } catch (e) { /* egal */ }
        steps.forEach(function (s) { s.hidden = true; });
        stepItems.forEach(function (item) { item.classList.add('is-done'); item.classList.remove('is-active'); });
        if (kicker) kicker.hidden = true;
        if (done) {
          done.hidden = false;
          done.setAttribute('tabindex', '-1');
          done.focus({ preventScroll: true });
        }
        scrollHierher();
        if (core) core.kontakt({ name: (form.vorname.value + ' ' + form.nachname.value).trim(), email: form.email ? form.email.value.trim() : '', telefon: form.telefon ? form.telefon.value.trim() : '', firma: form.unternehmen ? form.unternehmen.value.trim() : '' });
        track();
      } else if (msg) {
        msg.textContent = event.data.message || cfg.errorSend || 'Beim Versenden ist etwas schiefgelaufen. Bitte rufen Sie uns kurz an.';
        if (core) core.track('picura_form_fail', { form_id: 'pakete', reason: 'server' });
      }
    });

    form.addEventListener('focusin', function () {
      if (started) return;
      started = Date.now();
      if (core) core.track('picura_form_start', { form_id: 'pakete', entry: 'kontakt' });
    });

    /* ---------- Start ---------- */
    var wieder = restore();
    show(wieder || 1, false);
  }

  /* ---------- Sprungmarken ----------
     Links wie "Kostenloses Angebot anfragen" sollen die Paketauswahl wirklich ins Bild holen. */
  function stickyHoehe() {
    var found = 0;
    var cands = document.querySelectorAll('.shopify-section-group-header-group, .pch, header, .header, .announcement-bar');
    Array.prototype.forEach.call(cands, function (el) {
      var pos = getComputedStyle(el).position;
      if (pos !== 'sticky' && pos !== 'fixed') return;
      var box = el.getBoundingClientRect();
      if (box.bottom <= 0 || box.top > 160 || box.height < 20) return;
      if (box.bottom > found) found = box.bottom;
    });
    return Math.min(found, 200);
  }

  function springeZu(section) {
    var offset = stickyHoehe() + 12;
    var ziel = section.querySelector('.pk') || section;
    var top = window.pageYOffset + ziel.getBoundingClientRect().top - offset;
    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: smooth ? 'smooth' : 'auto' });
  }

  function sectionZuHash(hash) {
    if (!hash || hash.length < 2) return null;
    var ziel;
    try { ziel = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (e) { ziel = null; }
    if (!ziel || !ziel.closest) return null;
    return ziel.closest('.picura-pakete');
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href]') : null;
    if (!link || link.target === '_blank') return;
    var href = link.getAttribute('href') || '';
    var hash = href.indexOf('#') > -1 ? href.slice(href.indexOf('#')) : '';
    if (!hash) return;
    var pfad = href.slice(0, href.indexOf('#'));
    if (pfad && pfad !== location.pathname && pfad !== location.pathname + location.search) return;
    var section = sectionZuHash(hash);
    if (!section) return;
    e.preventDefault();
    springeZu(section);
    if (history.replaceState) history.replaceState(null, '', hash);
  });

  function hashNachziehen() {
    var section = sectionZuHash(location.hash);
    if (section) setTimeout(function () { springeZu(section); }, 60);
  }

  function boot() { document.querySelectorAll('[data-pk-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', hashNachziehen);
  document.addEventListener('shopify:section:load', boot);
})();
